import React, { useContext, useState } from "react";
import { Td, Tooltip, Tr } from "@chakra-ui/react";
import MenuRUD from "components/Menu/MenuRUD";
import styled from "styled-components/macro";
import { IconGeneric } from "styled/Icons.styled";
import { BsCheckCircleFill } from "react-icons/bs";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { useSelector } from "react-redux";
import {
  __ACTIVAR,
  __DESACTIVAR
} from "request/configuration/__Activar_Desactivar";
import environment from "constants/apiConst";
import { __ShowVehicularDoor } from "../../../request/configuration/__VehicularDoor";
import { ConfigIconStatus } from "./components/LoadingConfig";

const TdState = styled(Td)`
  color: ${(props) => (props.text === 1 ? "#58D68D" : "#F1948A")};
`;
const TbodyVehicularDoor = ({ data }) => {
  const token = useSelector((state) => state.auth.dataUser.token);
  const { setUpdate, update, setLoading } = useContext(
    ConfigurationCRUDContext
  );
  const [openAlert] = AlertErrorAlert();
  const [loadingIcons, setLoadingIcons] = useState(false);

  const desactivarAndActivar = async (result) => {
    setLoading(true);
    try {
      const resultado =
        result === 1
          ? await __DESACTIVAR(
            token,
            environment.VEHICULAR_DOOR_DESACTIVE,
            data.id
          )
          : await __ACTIVAR(token, environment.VEHICULAR_DOOR_ACTIVE, data.id);
      if (resultado.data.status.code !== 200) {
        openAlert(resultado.data.status.message, "error");
      } else {
        setUpdate(!update);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleState = async () => {
    if (loadingIcons) return;

    setLoadingIcons(true);
    try {
      const res = await __ShowVehicularDoor(token, data.id);
      const result = res.data.status.data.status_vehicularDoor;
      desactivarAndActivar(result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingIcons(false);
    }
  };

  return (
    <Tr>
      <Td className="text-center">{data.name_vehicularDoor}</Td>
      <Td className="text-center">
        {data?.type_vehicular_door_entry === 1 &&
        data?.type_vehicular_door_exit === 1
          ? "Entrada/Salida"
          : data?.type_vehicular_door_entry === 1 &&
            data?.type_vehicular_door_exit === 0
            ? "Entrada"
            : data?.type_vehicular_door_exit === 1 &&
            data?.type_vehicular_door_entry === 0
              ? "Salida"
              : "N/A"}
      </Td>
      <Tooltip
        placement="top"
        hasArrow
        label={data?.status_vehicularDoor === 1 ? "Desactivar" : "Activar"}
      >
        <TdState
          onClick={handleState}
          className="text-center"
          isNumeric
          text={data?.status_vehicularDoor}
        >
          <ConfigIconStatus
            loading={loadingIcons}
            status={data?.status_vehicularDoor}
          />
        </TdState>
      </Tooltip>
      <Td className="text-center" isNumeric>
        <MenuRUD data={data} />
      </Td>
    </Tr>
  );
};

export default TbodyVehicularDoor;
